<template>
  <div class="content-editor-block content-editor-code code">
    <textarea @input="onInput" v-html="initValue" ref="input"></textarea>
    <!-- <el-input v-model="mValue" @input="onInput" type="textarea" autosize placeholder="請輸入內文"></el-input> -->
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: ''
    }
  },
  data: () => {
    return {
      initValue: '',
      mValue: '',
      editor: null
    }
  },
  computed: {},
  methods: {
    onInput () {
      this.mValue = this.editor.getData()
      this.$emit('input', this.mValue)
    }
  },
  created () {
    this.initValue = this.value
    this.mValue = this.value
  },
  mounted () {
    let defaultFontColors = {
      colors: [
        { color: 'hsl(0, 0%, 0%)', label: 'Black' },
        { color: 'hsl(0, 0%, 30%)', label: 'Dim grey' },
        { color: 'hsl(0, 0%, 60%)', label: 'Grey' },
        { color: 'hsl(0, 0%, 90%)', label: 'Light grey' },
        { color: 'hsl(0, 0%, 100%)', label: 'White', hasBorder: !0 },
        { color: 'hsl(0, 75%, 60%)', label: 'Red' },
        { color: 'hsl(30, 75%, 60%)', label: 'Orange' },
        { color: 'hsl(60, 75%, 60%)', label: 'Yellow' },
        { color: 'hsl(90, 75%, 60%)', label: 'Light green' },
        { color: 'hsl(120, 75%, 60%)', label: 'Green' },
        { color: 'hsl(150, 75%, 60%)', label: 'Aquamarine' },
        { color: 'hsl(180, 75%, 60%)', label: 'Turquoise' },
        { color: 'hsl(210, 75%, 60%)', label: 'Light blue' },
        { color: 'hsl(240, 75%, 60%)', label: 'Blue' },
        { color: 'hsl(270, 75%, 60%)', label: 'Purple' }
      ],
      columns: 5
    }
    var fontColors = defaultFontColors
    fontColors.colors.push({ color: 'rgba(244,187,70,1)', label: '王ㄧ' })
    let opts = {
      alignment: {
        options: ['center', 'left', 'right']
      },
      toolbar: [
        'heading',
        '|',
        'bold',
        'italic',
        'Underline',
        'Strikethrough',
        '|',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        'alignment',
        '|',
        'fontSize',
        'fontFamily',
        'fontColor',
        'fontBackgroundColor',
        '|',
        'undo',
        'redo'
      ],
      link: {
        decorators: {
          isExternal: {
            mode: 'manual',
            label: 'Open in a new tab',
            attributes: {
              target: '_blank'
            }
          }
        }
      },
      fontColor: fontColors,
      language: 'zh'
    }
    window.ClassicEditor.create(this.$refs.input, opts)
      .then(editor => {
        this.editor = editor

        editor.editing.view.document.on(
          'drop',
          (evt, data) => {
            evt.stop()
            data.preventDefault()
          },
          { priority: 'high' }
        )
        editor.editing.view.document.on(
          'dragover',
          (evt, data) => {
            evt.stop()
            data.preventDefault()
          },
          { priority: 'high' }
        )

        editor.model.document.on('change:data', () => {
          this.onInput()
        })
      })
      .catch(error => {
        console.error(error)
        alert('編輯器異常')
      })
  },
  watch: {
    value () {
      this.mValue = this.value
    }
  }
}
</script>
